import { useCallback } from 'react';

/**
 * Returns a stable callback that marks an inline cell edit as finished:
 * calls `setEditing(false)` then, after MUI's unmount/focus-restoration cycle
 * completes, programmatically returns focus to the cell element.
 */
export const useCellEditEnd = (
  ref: React.RefObject<HTMLElement | null>,
  onEnd: () => void
) =>
  useCallback(() => {
    onEnd();
    setTimeout(() => {
      if (!ref.current?.hasAttribute('tabindex')) {
        ref.current?.setAttribute('tabindex', '-1');
      }
      ref.current?.focus();
    }, 0);
  }, [ref, onEnd]);
